import { http } from 'services/http';
import { EXPENSES_GET_MANY, EXPENSES_GET_ONE } from 'api/query-keys.ts';
import type { TChangeExpenseStatusReq, TEntityIdRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useUpdateExpenseStatus = (expenseId: number) => {
  return useMutationBase<TEntityIdRes, unknown, TChangeExpenseStatusReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<TEntityIdRes>(`/v1/expenses/${expenseId}/status`, variables);

      return res.data;
    },

    invalidateCallback: () => [[EXPENSES_GET_ONE, expenseId], [EXPENSES_GET_MANY]],
  });
};
